import axios from 'axios'
import { unitUrl, getHeader } from './../config'

const state = {
  unitList: [],
  unitTypeList: []
}

const mutations = {
  SET_UNIT_TYPE_LIST (state, obj) {
    state.unitTypeList = obj
  },
  SET_UNIT_LIST (state, obj) {
    state.unitList = obj
  }
}

const actions = {
  getUnitTypeList: ({ commit }) => {
    axios.get(unitUrl + '/type', { headers: getHeader() })
      .then(response => {
        commit('SET_UNIT_TYPE_LIST', response.data.data)
      })
  },
  getUnitList: ({ commit }, payload) => {
    axios.get(unitUrl + '?begin=' + payload.begin + '&end=' + payload.end, { headers: getHeader() })
      .then(response => {
        commit('SET_UNIT_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
